/** Old → new. Kept for two releases; a live customer still uses the old URLs. */
export const COMPLIANCE_REDIRECTS: Record<string, string> = {
  '/ndis-standards': '/compliance/standards',
  '/ndis-standards/policies': '/compliance/policies',
  '/policies': '/compliance/policies',
  '/ndis-standards/compliance': '/compliance/hub',
  '/ndis-standards/complaints': '/compliance/complaints',
  '/ndis-standards/audits': '/compliance/audits',
  '/ndis-standards/knowledge-base': '/compliance/hub',
}
